export default __webpack_public_path__ + "static/media/NavLogo.16613c75.svg";